<div>
  <div class="flex flex-row flex-wrap align-items-center my-3">
    <h3 class="text-base font-medium text-800 pr-2">
      {{'UserPages.UserCompanyInfo.PageTitle' | translate}}
    </h3>

    <p-button
      *ngIf="!isEdit"
      (onClick)="onEditForm()"
      icon="pi pi-pencil"
      label="{{'UserPages.UserContactInfo.EditButton' | translate}}"
      styleClass="p-button-text p-button-primary"
      class="custom-text-button"/>

    <p-button
      *ngIf="isEdit"
      (onClick)="onCancelEdit()"
      icon="pi pi-times"
      label="{{'UserPages.UserContactInfo.CancelButton' | translate}}"
      styleClass="p-button-text p-button-danger"
      class="custom-text-button button-cancel mr-2"/>

    <p-button
      *ngIf="isEdit"
      (onClick)="onSave()"
      icon="pi pi-save"
      label="{{'UserPages.UserContactInfo.SaveButton' | translate}}"
      styleClass="p-button-primary"
      class="custom-text-button"/>
  </div>

  <form [formGroup]="formGroup">
    <div class="flex flex-column">
      <div class="field-row flex w-12 border-bottom">
        <div class="w-5">
          <label for="vat">{{'UserPages.UserCompanyInfo.RutFieldLabel' | translate}} *</label>
        </div>
        <div class="w-7">
          <span *ngIf="!isEdit" class="detail-text">{{profile?.vat}}</span>
          <input
            *ngIf="isEdit"
            pInputText
            id="vat"
            formControlName="vat"
            type="text"
            (keyup.enter)="validateSII()"
            (focusout)="validateSII()"
            placeholder="{{'UserPages.UserCompanyInfo.RutFieldPlaceholder' | translate}}"
            class="custom-input"/>
          <small *ngIf="submit && formGroup.controls['vat'].invalid"
            class="p-error">{{getErrorMessage('vat')}}</small>
          <small *ngIf="verifierDigitError"
            class="p-error">{{'UserPages.UserCompanyInfo.RutFormatError' | translate}}</small>
          </div>
        </div>

      <div class="field-row flex w-12 border-bottom">
        <div class="w-5">
          <label for="companyName">{{'UserPages.UserCompanyInfo.CompanyNameFieldLabel' | translate}} *</label>
        </div>
        <div class="w-7">
          <span *ngIf="!isEdit" class="detail-text">{{profile?.companyName}}</span>
          <input
            *ngIf="isEdit"
            pInputText
            id="companyName"
            formControlName="companyName"
            type="text"
            required
            placeholder="{{'UserPages.UserCompanyInfo.CompanyNameFieldPlaceholder' | translate}}"
            class="custom-input"/>
          <small *ngIf="submit && formGroup.controls['companyName'].invalid"
            class="p-error">{{getErrorMessage('companyName')}}</small>
        </div>
      </div>

      <div class="field-row flex w-12 border-bottom" *ngIf="profile?.type == 1">
        <div class="w-5">
          <label for="sag">{{'UserPages.UserCompanyInfo.SagCodeFieldLabel' | translate}}</label>
        </div>
        <div class="w-7">
          <span *ngIf="!isEdit" class="detail-text">{{profile?.sagCode}}</span>
          <p-inputNumber
            *ngIf="isEdit"
            id="sag"
            formControlName="sag"
            [useGrouping]="false" [maxlength]="9"
            placeholder="{{'UserPages.UserCompanyInfo.SagCodeFieldPlaceholder' | translate}}"
            class="custom-input-number"/>
        </div>
      </div>

      <div class="field-row flex w-12 border-bottom">
        <div class="w-5">
          <label for="legalRepresentative">{{'UserPages.UserCompanyInfo.CompanyLegalRepresentantNameFieldLabel' | translate}} *</label>
        </div>
        <div class="w-7">
          <span *ngIf="!isEdit" class="detail-text">{{profile?.legalRepresentativeName}}</span>
          <input
            *ngIf="isEdit"
            pInputText id="legalRepresentative"
            formControlName="legalRepresentative"
            type="text"
            required placeholder="{{'UserPages.UserCompanyInfo.CompanyLegalRepresentantNameFieldPlaceholder' | translate}}"
            class="custom-input"/>
          <small *ngIf="submit && formGroup.controls['legalRepresentative'].invalid"
            class="p-error">{{getErrorMessage('legalRepresentative')}}</small>
        </div>
      </div>

      <div class="field-row flex w-12 border-bottom">
        <div class="w-5">
          <label for="legalRepresentativeId">{{'UserPages.UserCompanyInfo.CompanyLegalRepresentantNuipFieldLabel' | translate}} *</label>
        </div>
        <div class="w-7">
          <span *ngIf="!isEdit" class="detail-text">{{profile?.legalRepresentativeNumber}}</span>
          <input
            pInputText
            *ngIf="isEdit"
            id="legalRepresentativeId"
            formControlName="legalRepresentativeId"
            placeholder="{{'UserPages.UserCompanyInfo.CompanyLegalRepresentantNuipFieldPlaceholder' | translate}}"
            class="custom-input"/>
          <small *ngIf="submit && formGroup.controls['legalRepresentativeId'].invalid"
            class="p-error">{{getErrorMessage('legalRepresentativeId')}}</small>
        </div>
      </div>

      <!-- Solo para usuario exportador -->
      <div *ngIf="profile?.type === 1" class="field col-12 mt-3 flex gap-3">
        <div class="flex flex-column w-12 lg:w-6">
          <label>{{'UserPages.UserCompanyInfo.ExporterCompanyLogoFieldLabel' | translate}}</label>
          <!-- Se setea [maxFileSize]="1048576" para permitir 1MB de peso -->
          <p-fileUpload
            (onSelect)="onSelectLogo($event)"
            [showUploadButton]="false"
            [multiple]="false"
            [maxFileSize]="1048576"
            accept=".png,.jpg,.svg"
            chooseLabel="{{'UserPages.UserCompanyInfo.SelectImageButton' | translate}}"
            cancelLabel="{{'UserPages.UserCompanyInfo.CancelImagesButton' | translate}}"
            invalidFileSizeMessageSummary="{{'UserPages.UserCompanyInfo.ExporterCompanyLogoInvalidFileLabel' | translate}}"
            invalidFileSizeMessageDetail="{{'UserPages.UserCompanyInfo.ExporterCompanyLogoInvalidSizeLabel' | translate}}"
            [disabled]="!isEdit"
            class="file-uploader">
            <ng-template pTemplate="content" let-files>
              <div *ngIf="formGroup.get('logo')?.value && exporterLogo.length === 0"
                class="flex flex-row justify-content-between align-content-center align-items-center">
                <div class="flex align-content-center align-items-center">
                  <img
                    [src]="profile?.logoUrl | speciesImageUrl"
                    alt="logo"
                    class="logo"/>
                  <span class="pl-8">
                    {{'UserPages.UserCompanyInfo.ExporterLogoNameLabel' | translate}}
                  </span>
                </div>

                <p-button
                  icon="pi pi-times"
                  class="custom-button"
                  (onClick)="removeLogo()"
                  [disabled]="!isEdit">
                </p-button>
              </div>
            </ng-template>
          </p-fileUpload>
        </div>
        <div class="flex flex-column w-12 lg:w-3">
          <label>{{'UserPages.UserCompanyInfo.PrimaryColorLabel' | translate}}</label>
          <div class="flex-1 flex flex-column align-items-start gap-1 mt-2">
            <p-colorPicker
              formControlName="primaryColor"
              defaultColor="#ffffff"
              [disabled]="!isEdit"/>
            <div class="flex flex-row">
              <span class="font-bold pr-2">HEX:</span>
              <span>{{ formGroup.controls['primaryColor'].value || ('UserPages.UserCompanyInfo.EmptyColorLabel' | translate)}}</span>
            </div>
          </div>
        </div>
        <div class="flex flex-column w-12 lg:w-3">
          <label>{{'UserPages.UserCompanyInfo.SecondaryColorLabel' | translate}}</label>
          <div class="flex-1 flex flex-column align-items-start gap-1 mt-2">
            <p-colorPicker
              formControlName="secondaryColor"
              defaultColor="#ffffff"
              [disabled]="!isEdit || !formGroup.controls['primaryColor'].value"/>
            <div class="flex flex-row">
              <span class="font-bold pr-2">HEX: </span>
              <span>{{ formGroup.controls['secondaryColor'].value || ('UserPages.UserCompanyInfo.EmptyColorLabel' | translate)}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="field col-12 mt-3">
        <label>{{'UserPages.UserCompanyInfo.CompanyLegalDocumentFieldLabelPart1' | translate}} <span>PDF</span> {{'UserPages.UserCompanyInfo.CompanyLegalDocumentFieldLabelPart2' | translate}}.</label>
        <p-fileUpload
          (onSelect)="onSelect($event)"
          [showUploadButton]="false"
          [multiple]="false"
          accept=".pdf"
          [maxFileSize]="5000000"
          chooseLabel="{{'UserPages.UserCompanyInfo.SelectImageButton' | translate}}"
          cancelLabel="{{'UserPages.UserCompanyInfo.CancelImagesButton' | translate}}"
          [disabled]="!isEdit"
          class="file-uploader">
          <ng-template pTemplate="content" let-files>
            <div *ngIf="formGroup.get('pdfFile')?.value && uploadedFiles.length === 0"
              class="flex flex-row justify-content-between align-content-center align-items-center">
              <div class="flex flex-row justify-content-center align-content-center align-items-center">
                <p-button
                  (onClick)="downloadFile(profile!.pdfUrl!)"
                  icon="pi pi-file-pdf"
                  styleClass="p-button-outlined"
                  class="custom-text-button pdf-icon"/>
                <span class="pl-8">
                  {{'UserPages.UserCompanyInfo.PdfDocumentNameLabel' | translate}}
                </span>
              </div>

              <p-button
                icon="pi pi-times"
                class="custom-button"
                (onClick)="removeFile()"
                [disabled]="!isEdit">
              </p-button>
            </div>
          </ng-template>
        </p-fileUpload>
      </div>

    </div>
  </form>
</div>


